import { get, readable, writable } from "svelte/store";
export class Race {
    get endTime() {
        return this._endTime;
    }
    constructor(routeId, startCheckpointId, startTime, challengePoints, track = [], points = 0, isEnded = false, endTime = null) {
        this.routeId = routeId;
        this.startCheckpointId = startCheckpointId;
        this.startTime = startTime;
        this.challengePoints = challengePoints;
        this._points = writable(0);
        this._isEnded = writable(false);
        this._endTime = null;
        this.track = new Map();
        this.points = readable(0, set => this._points.subscribe(set));
        this.isEnded = readable(false, set => this._isEnded.subscribe(set));
        for (const { checkpointId, time } of track) {
            this.track.set(checkpointId, time);
        }
        this._points.set(points);
        this._isEnded.set(isEnded);
        this._endTime = endTime;
    }
    setEnded() {
        if (get(this._isEnded)) {
            return;
        }
        this._isEnded.set(true);
        this._endTime = new Date();
    }
    hasCheckpointInTrack(checkpointId) {
        return this.track.has(checkpointId);
    }
    addRaceCheckpoint(checkpointId) {
        if (this.hasCheckpointInTrack(checkpointId)) {
            return;
        }
        this.track.set(checkpointId, Date.now());
    }
    getState() {
        var _a;
        return {
            routeId: this.routeId,
            startCheckpointId: this.startCheckpointId,
            startTime: this.startTime.getTime(),
            challengePoints: this.challengePoints.map(challengePoint => challengePoint.getState()),
            track: [...this.track].map(([checkpointId, time]) => ({ checkpointId, time })),
            points: get(this._points),
            isEnded: get(this._isEnded),
            endTime: ((_a = this.endTime) === null || _a === void 0 ? void 0 : _a.getTime()) || null,
        };
    }
    addPoints(points) {
        if (points < 0) {
            throw new Error('No se pueden añadir puntos negativos.');
        }
        this._points.update(current => current + points);
    }
    /**
     * Retorna el tiempo de carrera en segundos.
     * Si la carrera no ha terminado retorna el tiempo desde el comienzo de la carrera hasta ahora.
     */
    getRaceTime() {
        const toTime = get(this.isEnded) ? this.endTime : new Date;
        return Math.floor((toTime.getTime() - this.startTime.getTime()) / 1000);
    }
}
